export const INITIAL_VALUES = {
  group_at: null,
  group_for: null,
  date_start: '',
  date_finish: '',
  isTransfered: 0,
};
